import '../styles/footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <p className="site-footer-copy">
        Rättigheter ägs av Arya Eisa · © {year}
      </p>
    </footer>
  );
}

export default Footer;
